module.exports = __webpack_public_path__ + "imgs/651f27f321246163f6bcd433e36dba59.jpg";